<template>
  <div class="d-flex">
    <div class="tools-wrapper">
      <h3
        class="px-3 py-2 font-weight-700 font-size-24 custom-headline color-custom-blue border-bottom-gray"
      >
        ALL Fields
      </h3>
      <div class="tools-wrapper-inner">
        <Container
          group-name="form-builder-grpup"
          @drop="onDrop('field_list', $event)"
          :get-child-payload="getChildPayload1"
          behaviour="copy"
          class="d-flex flex-wrap"
        >
          <Draggable v-for="data in field_list" :key="data.id">
            <div class="btx-draggable">
              <img :src="$assetURL(data.icon)" alt="" width="18" class="mr-1" />
              {{ data.name }}
            </div>
          </Draggable>
        </Container>
      </div>
    </div>
    <div class="formBuilder-wrapper">
      <v-layout
        class="px-3 border-bottom-gray d-flex align-center sticky-title"
      >
        <h3
          class="font-weight-700 font-size-24 custom-headline color-custom-blue"
        >
          Preview
        </h3>
        <v-spacer></v-spacer>
      </v-layout>
      <div id="formBuilderDiv" class="formBuilder-inner overflow-auto">
        <div
          class="builderFormWrapperView"
          :class="db_components.length == 0 ? 'form-blank' : ''"
        >
          <Container
            group-name="form-builder-grpup"
            @drop="onDrop('db_components', $event)"
            :get-child-payload="getChildPayload2"
            :drop-placeholder="dropPlaceholderOptions"
            class="form-drag-container builderFormWrapper"
          >
            <Draggable
              v-for="(element, index) in db_components"
              :key="index"
              class="selectedType"
            >
              <div class="form-fields py-5" v-if="element">
                <div class="form-grp px-5">
                  <div class="actions">
                    <v-icon
                      v-if="element.is_setting"
                      class="setting"
                      v-on:click="() => manageDrawer(element, index)"
                      >mdi-cog</v-icon
                    >
                    <v-icon class="duplicate" v-on:click="copy_element(index)"
                      >mdi-content-duplicate</v-icon
                    >
                    <v-icon class="delete" v-on:click="delete_element(index)"
                      >mdi-delete-outline</v-icon
                    >
                  </div>
                  <label class="fw-500" v-if="element && !element.hidelabel">{{
                    element.label
                  }}</label>
                  <template>
                    <v-row>
                      <v-col
                        :md="element.column"
                        v-for="(choice, coiceIndex) in element.choices"
                        :key="`choice-${coiceIndex}`"
                      >
                        <v-checkbox
                          hide-details
                          v-model="choice.check_status"
                          :label="choice.label"
                          class="mt-0"
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                  </template>
                  <p
                    class="text-muted mt-2 mb-0"
                    v-if="element && element.instructions != null"
                  >
                    {{ element.instructions }}
                  </p>
                </div>
              </div>
            </Draggable>
            <Drawer
              :drawer="drawerDialog"
              v-on:close="drawerDialog = false"
              v-on:success="manageData"
              :propertiesData="properties"
              :filedData="DrawerData"
            ></Drawer>
          </Container>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Container, Draggable } from "vue-smooth-dnd";
import FieldList from "@/view/pages/serviceFormTemplate/FieldList.json";
import Drawer from "@/view/pages/serviceFormTemplate/components/Drawer";
import { cloneDeep, find, map } from "lodash";
export default {
  name: "Form_builder",
  props: {
    data: {
      type: Object,
      default: new Object(),
    },
    preBuilderData: {
      type: Array,
      default: new Array(),
    },
    title: {
      type: String,
      default: null,
    },
  },
  watch: {
    preBuilderData: {
      handler(param) {
        console.log({ param });
        let data = map(param, (row) => {
          let returnData = row;
          let fieldData = row;
          if (row.type) {
            fieldData = FieldList[0];
            // fieldData = find(FieldList, (fieldRow) => fieldRow.type == row.type);
            fieldData.properties = returnData;
          }
          return fieldData;
        });
        this.db_components = data;
        this.emitData();
      },
      deep: true,
      immediate: true,
    },
    title: {
      handler(param) {
        this.form_title = param;
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      drawerDialog: false,
      field_list: FieldList,
      form_title: null,
      drawer_type: null,
      db_components: [],
      dropPlaceholderOptions: {
        className: "drop-preview",
        animationDuration: "50",
        showOnTop: true,
      },
      properties: {},
      db_index: null,
      DrawerData: [],
    };
  },
  methods: {
    manageDrawer(data, index) {
      this.drawerDialog = true;
      this.drawer_type = data.type;
      this.DrawerData = cloneDeep(data.DrawerData);
      this.properties = cloneDeep(data);
      this.db_index = index;
    },
    manageData(data) {
      this.drawerDialog = false;
      let dbComponentData = cloneDeep(this.db_components);
      dbComponentData[this.db_index] = cloneDeep(data);
      console.log({ dbComponentData });
      this.db_components = dbComponentData;
      this.emitData();
    },
    // copy_element(index) {
    //     this.db_components.splice(index + 1, 0, this.db_components[index]);
    //     this.emitData();
    // },
    copy_element(index) {
      const clonedItem = cloneDeep(this.db_components[index]);
      clonedItem.is_setting = true;
      this.db_components.splice(index + 1, 0, clonedItem);
      this.emitData();
    },
    delete_element(index) {
      this.db_components.splice(index, 1);
      this.emitData();
    },
    onDrop(collection, dropResult) {
      console.log({ collection, dropResult });
      this[collection] = this.applyDrag(this[collection], dropResult);
      this.emitData();
    },
    getChildPayload1(index) {
      return this.field_list[index];
    },
    getChildPayload2(index) {
      return this.db_components[index];
    },
    applyDrag(arr, dragResult) {
      const { removedIndex, addedIndex, payload } = dragResult;
      if (removedIndex === null && addedIndex === null) return arr;
      const result = [...arr];
      let itemToAdd = payload;
      if (removedIndex !== null) {
        itemToAdd = result.splice(removedIndex, 1)[0];
      }
      if (addedIndex !== null) {
        result.splice(addedIndex, 0, itemToAdd);
      }
      return result;
    },
    emitData() {
      const _this = this;
      _this.$emit("update-data", _this.db_components);
    },
    initData() {
      const _this = this;
      let builderData = cloneDeep(_this.data);
      if (builderData.builder_data.length > 0) {
        let data = map(builderData.builder_data, (row) => {
          if (row.properties) {
            return row;
          } else {
            let returnData = row;
            returnData.hidelabel = Number(returnData.hidelabel);
            let fieldData = find(
              FieldList,
              (fieldRow) => fieldRow.type == row.type
            );
            fieldData.properties = returnData;
            return fieldData;
          }
        });
        this.db_components = data;
        alert(2);
      }
    },
  },
  mounted() {
    //this.initData();
  },
  components: {
    Container,
    Draggable,
    Drawer,
  },
};
</script>
<style scoped>
.sticky-title {
  padding-top: 6px;
  padding-bottom: 7px;
  position: sticky;
  top: 0;
  background: #eef0f8;
  z-index: 6;
}

.page-break {
  position: relative;
  width: 100%;
  height: 50px;
  /* Adjust height as needed */
  display: flex;
  align-items: center;
  justify-content: center;
}

.page-break::before,
.page-break::after {
  content: "";
  position: absolute;
  top: 24px;
  bottom: 0;
  width: 30%;
  height: 2px;
  background-color: black;
}

.page-break::before {
  left: 10%;
}

.page-break::after {
  right: 10%;
}

.page-break span {
  background: white;
  padding: 0 10px;
  font-size: 18px;
  font-weight: bold;
}

.signatureDiv {
  width: 100%;
  height: 100px;
  border: 1px dashed;
  margin-top: 23px;
}
</style>
